import { Span } from '@afterpaytouch/core'
import styles from './style.module.css'
import React, { useContext } from 'react'
import { useTranslation } from '../../utils/convergence'
import { usePreferredCard, useTopazState } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { hasCardTopazErrorReason } from '../../model'
import { isNullOrUndefined } from '@afterpay/utils'
import { SummaryNotificationContext } from '../SummaryNotification'

export const PreferredCardTopazError = (): JSX.Element | null => {
  const { notification } = useContext(SummaryNotificationContext)
  const { t } = useTranslation()
  const topazState = useTopazState()
  const { card, reason, switched } = usePreferredCard() ?? {}
  const { smallTextSize } = useCheckoutSizes()

  const showPreferredCardTopazError = notification != null && hasCardTopazErrorReason(card) && !switched && !isNullOrUndefined(topazState.purchase.selected)

  if (!showPreferredCardTopazError) {
    return null
  }
  return (
    <div className={styles.errorContainer}>
      <Span size={smallTextSize} color='Fire' testNameSpace='preferred-card-topaz-error'>
        {t(`summary:error:${reason}:message`, { context: 'cannotSwitch' })}
      </Span>
    </div>
  )
}
